import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {GlobalConstantsComponent} from '../../shared/global-constants/global-constants.component';

@Injectable({
  providedIn: 'root'
})
export class AdminProcessService {

  private apiUrl = GlobalConstantsComponent.apiURL;

  constructor(
    private http: HttpClient
  ) { }

  /***********************************************************************************************************************
   *                                                APPELS API
   ***********************************************************************************************************************/

  validateBooking(bookingId){
    return this.http.post(`${this.apiUrl}care/validateBooking`, bookingId);
  }

  refuseBooking(bookingId, refuseReason?){
    const datas = {'bookingId': bookingId, 'refuseReason': refuseReason};
    return this.http.post(`${this.apiUrl}care/refuseBooking`, datas);
  }

  sendToPartner(bookingId) {
    return this.http.post(`${this.apiUrl}care/bookingToPartner`, bookingId);
  }

  cancelBooking(bookingId) {
    return this.http.post(`${this.apiUrl}care/cancelBooking`, bookingId);
  }
  setBookingPendingReason(bookingId,reason) {
    return this.http.post(`${this.apiUrl}care/setPendingReason`, {bookingId, reason});
  }

  setPropertyPhotos(photos){
    return this.http.post(this.apiUrl + 'setPropertyPhotos', photos);
  }

  deletePropertyPhoto(photoId){
    return this.http.get(this.apiUrl + 'deletePropertyPhoto/' + photoId);
  }

  getRoomByCity(city: number) {
    return this.http.post(`${this.apiUrl}getRoomsByCity`, {data: city}  );
  }

  getCharges() {
    return this.http.get(`${this.apiUrl}listCharges`);
  }

  getFaq(){
    return this.http.get(`${this.apiUrl}listFaq`);
  }

  updatePropertyField(id,field,value){
    return this.http.post(`${this.apiUrl}care/updatePropertyField`, {id: id,field:field,value:value}  );
  }

  updatePropertyFields(id,fields) {
  return this.http.post(`${this.apiUrl}care/updatePropertyFields`, { id, fields }) as any;
}


  resetPhotos(id){
    return this.http.get(`${this.apiUrl}care/resetPhotos/`+ id  );
  }
  resetMultiplePhotos(pptiesIds){
    return this.http.post(`${this.apiUrl}care/resetMultiplePhotos`, {pptiesIds: pptiesIds});
  }

  downloadPhotos(pptIds){
    return this.http.post(`${this.apiUrl}care/downloadPhotos/`, {pptIds: pptIds});
  }

  /**
   * Renvoi un array soit vide (pas de propriétés) soit avec des chambres (Pas formaté pour ES)
   * @param id
   */
  getHouseProperties(id) {
    return this.http.get(`${this.apiUrl}care/getHouseProperties/` + id) as any;
  }

  updateBookingDocuments(bookingId: number, documentId: number, docType: string, type?: string) {
    return this.http.post(`${this.apiUrl}care/updateBookingDocuments/`, { bookingId, docId: documentId, docType, type });
}


  /***********************************************************************************************************************
   *                                                CALCUL/UTILITIES
   ***********************************************************************************************************************/




  //---------------------------------------------------------------------------------------------------------------------



}
